module.exports = __webpack_public_path__ + "static/media/arrow-up.0f20325e.svg";